import { Table, Pagination } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { getLeavesApi } from "api/services/employee";
import { formatDateHandler2 } from "utils/common";
import EmployeeLeaveModelPopup from "../../components/modelpopup/EmployeeLeaveModelPopup";
import { getLeaveType } from 'api/services/common';

import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";
import Image from "components/Image";




const EmployeeLeave = ({filters, userData}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [selectedLeave, setSelectedLeave] = useState("");
  const [leaveModal, setLeaveModal] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);

    const [leaves, setLeaves] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageSettings , setPageSettings] = useState({
      ...defaultPagination,
        sortType: "asc",
        sortBy: "leave_type__code"
      })

    useEffect(()=>{
      console.log(userData, "KKKKKKK")
      if(userData?.id){
       
      setLoading(true)
      fetchLeaveList()
      }

    },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, userData])
    useEffect(()=>{
      getLeaveType().then(res=>{
        setLeaveTypes(res.data.results.map(item=>{
          return{
            label: `${item.code} - ${item.description}`,
            value: item.id
          }
        }))
      })
    },[])
    const fetchLeaveList = () => {
      let params = {
        // user: userData?.id,
        sort_by: pageSettings?.sortBy,
        sort_type: pageSettings?.sortType,
        page_size: pageSettings?.pageSize,
        page: pageSettings?.page,
        company_user: userData?.id,
        approval_status: "all"
    }

      getLeavesApi(params).then(response=>{
        setLeaves(response.data.results)
        setLoading(false)
        setPageSettings({
            ...pageSettings,
            total: response.data.count
        })
    })
    }

    const handleChange = (pagination, filters, sorter) =>{
        let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
        setPageSettings(pageData)
    }

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leave_type",
      render: (text, record) =>
        <Link to="#" className="cursor-pointer"
      style={{
       cursor: "pointer !important",
      }}

      onClick={()=>{
        setSelectedLeave(record)
        setLeaveModal(true)
      }}>
          {record?.leave_type?.description}
           </Link>
        ,
      sorter: false,
    },
    // {
    //     title: "Leave Code",
    //     dataIndex: "leave_type__code",
    //     render: (text, record) => <span>{record?.leave_type?.code}</span>,
    //     sorter: true,
    //   },
    {
      title: "From",
      dataIndex: "start_date",
      render: (text, record) => <span>{formatDateHandler2(record?.start_date)}</span>,

      sorter:   true,
    },
    {
      title: "To",
      dataIndex: "end_date",
      render: (text, record) => <span>{formatDateHandler2(record?.end_date)}</span>,

      sorter: true,
    },

    {
      title: "No Of Days",
      dataIndex: "no_of_days",
      render: (text, record) => <span>{text}</span>,
      sorter: true,
    },

    {
      title: "Reason",
      dataIndex: "comment",
      render: (text, record) => <span>{text}</span>,

      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-${ text == "pending" ?  "warning" : text == "rejected" ? "danger" : "success"}`}>{text}</span>  

          {/* <Link
            className="btn btn-white btn-sm btn-rounded dropdown-toggle"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              className={
                text === "new"
                  ? "far fa-dot-circle text-purple"
                  : text === "pending"
                  ? "far fa-dot-circle text-info"
                  : text === "approved"
                  ? "far fa-dot-circle text-success"
                  : "far fa-dot-circle text-danger"
              }
            />{" "}
            {text}
          </Link>

          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-purple" /> New
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-info" /> Pending
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-success" /> Approved
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-danger" /> Declined
            </Link>
          </div> */}
        </div>
      ),
    },
    {
        title: "Approved On",
        dataIndex: "approved_on",
        render: (text) => <>{formatDateHandler2(text)}</>,
        // render: (text, record) => <div>
        //      <Link  to={`/employees/${record?.approved_by?.id}`}>
        //      {record?.approved_by?.first_name} {record?.approved_by?.last_name}
        //     </Link>
        // <br/>
        // <small>{record?.approved_by?.email}</small>
        // </div> ,
  
        sorter: true,
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        sorter: true,
        render: (text) => <>{formatDateHandler2(text)}</>,
      },
      {
        title: "Updated At",
        dataIndex: "updated_at",
        sorter: true,
        render: (text) => <>{formatDateHandler2(text)}</>,
      },
    {
      title: "Action",
      className: "text-end",
      sorter: false,
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_leave"
              onClick={()=>{
                setSelectedLeave(record)
                setLeaveModal(true)
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  const leaveStats = [
    {
      id: 1,
      title: "Annual Leave",
      value: 12,
    },
    {
      id: 2,
      title: "Medical Leave",
      value: 3,
    },
    {
      id: 3,
      title: "Other Leave",
      value: 4,
    },
    {
      id: 4,
      title: "Remaining Leave",
      value: 5,
    },
  ];

  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
					
  }

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {leaves.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
            <div className="contact-grid">
                <div className="grid-head">
                    <div className="users-profile">
                        <a  className="avatar">
                            {/* <img src={employee?.profile_image} alt="" /> */}
                            <Image  src={record.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        </a>
                        <h5 className="name-user">
                            <a >{record.company_user?.first_name} {record?.company_user?.last_name} </a>
                            <span>{record.company_user?.emp_no}</span>
                        </h5>
                    </div>
                 
                </div>
                <div className="grid-body">
                    <div className="address-info">
                        <span>
                            <i className="la la-calendar" />
                            From : {formatDateHandler2(record.start_date)}
                            {/* sharon@gmail.com */}
                        </span>
                        <span>
                            <i className="la la-calendar" />
                            To : {formatDateHandler2(record.end_date)}
                        </span>
                        <span>
                            <i className="la la-calendar-week" />
                            Number of days : {record.no_of_days}
                        </span>
                    </div>
                    <div className="grid-badges">
                        <span className="badge badge-soft-warning">{record?.leave_type?.description}</span>
                    </div>
                </div>
               
            </div>
        </div>
          
          ))}
        </>
      );
    }
  };
  
  return (
    <>
    {
      isMobile ?
      <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
      :
      <div className="table-responsive">
        <Table
        // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
            columns={columns}
            dataSource={leaves}
            className="table-striped"
            loading={loading}
            pagination={{
                total: pageSettings?.total,
                pageSize: pageSettings?.pageSize,
                showSizeChanger: true,
                pageSizeOptions: pageSizeOptions,
                // showQuickJumper: true,
                itemRender: itemRender,
                position:"right",
                current:pageSettings?.page,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
            }}
            onChange={handleChange}

        />
              <EmployeeLeaveModelPopup fetchLeaveList={fetchLeaveList} selectedLeave={selectedLeave} setSelectedLeave={setSelectedLeave} leaveTypes={leaveTypes} leaveModal={leaveModal} setLeaveModal={setLeaveModal} />

        </div>

    }
        
    </>
  );
};

export default EmployeeLeave;
